module.exports = __webpack_public_path__ + "static/media/May2022Newsletter.c494135c.pdf";